import { downloadFile } from "../helpers";

function DownloadButton( props: {file: string, children: string} ) {
    return (
        <button className="majorButton" onClick={() => {downloadFile(props.file)}}>{props.children}</button>
    )
}
export default DownloadButton;